import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "section", "navItem"]

  open() {
    this.modalTarget.classList.remove("hidden")
    document.body.classList.add("overflow-hidden")
  }

  close() {
    this.modalTarget.classList.add("hidden")
    document.body.classList.remove("overflow-hidden")
  }

  closeOnBackdrop(event) {
    if (event.target === this.modalTarget) {
      this.close()
    }
  }

  showSection(event) {
    const sectionId = event.currentTarget.dataset.guideSection

    this.sectionTargets.forEach((section) => {
      section.classList.toggle("hidden", section.id !== sectionId)
    })

    this.navItemTargets.forEach((item) => {
      const isActive = item.dataset.guideSection === sectionId
      const isMobile = item.closest("nav.sm\\:hidden") !== null

      if (isMobile) {
        item.classList.toggle("text-amber-400", isActive)
        item.classList.toggle("bg-amber-500/10", isActive)
        item.classList.toggle("text-[#9ca3af]", !isActive)
      } else {
        item.classList.toggle("text-amber-400", isActive)
        item.classList.toggle("border-l-2", isActive)
        item.classList.toggle("border-amber-500", isActive)
        item.classList.toggle("text-[#9ca3af]", !isActive)
      }
    })
  }

  // Close on Escape key
  closeOnEscape(event) {
    if (event.key === "Escape") {
      this.close()
    }
  }
}
